import React from 'react';
import Styled from 'styled';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import ButtonView from '../button-view';
import defaultStyles from './big-button-view.scss';


@Styled(defaultStyles)
class BigButtonView extends React.PureComponent {
    render() {
        const { icon, label, styles, ...rest } = this.props;

        const classNames = [styles.wrapper];

        if (label) {
            classNames.push(styles.hasLabel);
        }

        return (
            <ButtonView {...rest} styles={styles}>
                <span className={classNames.join(' ')}>
                    {icon ? <SVGIcon style={{image: styles.icon}} src={icon} /> : null}
                    {label}
                </span>
            </ButtonView>
        );
    }
}

export default BigButtonView;
